import { ValidationSchemaType } from 'hooks/useForm';
import { NestedProductCategory } from '../types/dtos';

export const NESTED_PRODUCT_CATEGORY_INITIAL_FIELDS: NestedProductCategory = {
    name: '',
    isActive: 'ACTIVE',
    isMultiSelect: 'NO',
    maxSelection: '',
};

export const NESTED_PRODUCT_CATEGORY_FIELDS_SCHEMA: ValidationSchemaType<NestedProductCategory> = {
    name: {
        required: true,
        maxLength: 100,
    },
    isActive: {
        required: true,
    },
    isMultiSelect: {
        required: true,
    },
    maxSelection: {
        type: 'max_selection',
    },
};
